export default __webpack_public_path__ + "static/media/craig-cameron-BTqLREyDs2Q-unsplash.7a6cb439.jpg";